export class PlayerBuffer {
    constructor(
    /** size of buffer */
    size = 1000, events = [], index = 0) {
        this.size = size;
        this.events = events;
        /** timestamp of first page instance */
        this.firstPaint = Infinity;
        /** the largest time in queue, which is of course the latest event */
        this.lastTime = Infinity;
        /** buffer index */
        this.bidx = 0;
        /** length of events removed from start  */
        this.headLength = 0;
        this.bidx = index;
        this.measure();
    }
    get index() {
        return this.bidx + this.headLength;
    }
    get current() {
        return this.events[this.bidx];
    }
    get length() {
        return this.events.length + this.headLength;
    }
    at(i) {
        return this.events[i - this.headLength];
    }
    /** peek ms time forward */
    peek(ms = 1) {
        var _a;
        const peekTime = ((_a = this.current) === null || _a === void 0 ? void 0 : _a.time) + ms;
        const events = [];
        for (let i = this.bidx; i < this.events.length && this.events[i].time <= peekTime; i++) {
            events.push(this.events[i]);
        }
        return events;
    }
    /** increase index upto buffer length */
    next(count = 1) {
        return ((this.bidx = Math.min(this.bidx + count, this.events.length)) <
            this.events.length);
    }
    /** seek index to just after time stamp, without exceeding end */
    seek(time) {
        const index = this.events.findIndex((event) => event.time > time);
        this.bidx = index === -1 ? this.events.length : index;
    }
    append(event) {
        if (event.type === "Batch") {
            this.events = this.events.concat(
            // this will make sure events play in the same order as offline playback
            // the main issue is that attachments are prepended but with greater timestamp
            event.payload.events.sort((a, b) => a.time - b.time));
        }
        else {
            this.events.push(event);
        }
        if (this.events.length > this.size) {
            this.events = this.events.slice(this.bidx);
            this.headLength += this.bidx;
            this.bidx = 0;
        }
        this.measure();
    }
    measure() {
        if (this.firstPaint === Infinity) {
            const firstInstance = this.events.find((ev) => ev.type === "Document" || ev.type === "TreeInstance");
            if (firstInstance) {
                this.firstPaint = firstInstance.time;
            }
        }
        if (this.events.length)
            // make sure it gets the largest value
            this.lastTime = Math.max(...this.events.slice(-3).map((e) => e.time));
    }
}
